// Age verify
function $97b0b8031f1ac0d4$var$setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function $97b0b8031f1ac0d4$var$getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
// Age verify
document.addEventListener("DOMContentLoaded", function(arg) {
    const cookie = $97b0b8031f1ac0d4$var$getCookie("is_legal");
    document.getElementById("allow-age").addEventListener("click", ()=>{
        document.body.classList.remove("overflow-hidden");
        document.getElementById("age-verify").classList.add("hidden");
        $97b0b8031f1ac0d4$var$setCookie("is_legal", true, 30);
    });
    document.getElementById("disallow-age").addEventListener("click", ()=>{
        document.location.href = "https://www.google.com/";
    });
    console.log(cookie);
    if (cookie) {
        document.body.classList.remove("overflow-hidden");
        document.getElementById("age-verify").classList.add("hidden");
    } else {
        document.body.classList.add("overflow-hidden");
        document.getElementById("age-verify").classList.add("opacity-100");
    }
});


document.addEventListener("DOMContentLoaded", function(arg) {
    let lastScrollTop = 0; // This Varibale will store the top position
    const navbar = document.getElementById("navbar"); // Get The NavBar
    window.addEventListener("scroll", function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDirection = lastScrollTop > scrollTop === true ? "top" : lastScrollTop < scrollTop === true ? "bottom" : "none";
        switch(scrollDirection){
            case "top":
                navbar.style.top = "0px";
                break;
            case "bottom":
                navbar.style.top = "-105px";
                break;
            case "none":
                break;
        }
        lastScrollTop = scrollTop; //New Position Stored
    });
});


// GA
window.dataLayer = window.dataLayer || [];
function $54b47fc030b7b21e$var$gtag() {
    dataLayer.push(arguments);
}
$54b47fc030b7b21e$var$gtag("js", new Date());
$54b47fc030b7b21e$var$gtag("config", "G-SDKRP5F8LM");
// GA
// Navigation
const $54b47fc030b7b21e$var$elm1 = document.getElementById("in-store.html");
const $54b47fc030b7b21e$var$elm2 = document.getElementById("delivery.html");
const $54b47fc030b7b21e$var$elm3 = document.getElementById("daily-deals.html");
switch(window.location.pathname){
    case "/index.html":
        if ($54b47fc030b7b21e$var$elm1) $54b47fc030b7b21e$var$elm1.style.opacity = "100";
        if ($54b47fc030b7b21e$var$elm2) $54b47fc030b7b21e$var$elm2.style.opacity = "100";
        if ($54b47fc030b7b21e$var$elm3) $54b47fc030b7b21e$var$elm3.style.opacity = "100";
        break;
    case "/in-store.html":
        if ($54b47fc030b7b21e$var$elm1) $54b47fc030b7b21e$var$elm1.style.textDecoration = "underline";
        if ($54b47fc030b7b21e$var$elm1) $54b47fc030b7b21e$var$elm1.style.color = "var(--color-primary)";
        if ($54b47fc030b7b21e$var$elm1) $54b47fc030b7b21e$var$elm1.style.fontWeight = "700";
        if ($54b47fc030b7b21e$var$elm1) $54b47fc030b7b21e$var$elm1.style.opacity = "100";
        break;
    case "/delivery-deals.html":
        if ($54b47fc030b7b21e$var$elm2) $54b47fc030b7b21e$var$elm2.style.textDecoration = "underline";
        if ($54b47fc030b7b21e$var$elm2) $54b47fc030b7b21e$var$elm2.style.color = "var(--color-primary)";
        if ($54b47fc030b7b21e$var$elm2) $54b47fc030b7b21e$var$elm2.style.fontWeight = "700";
        if ($54b47fc030b7b21e$var$elm2) $54b47fc030b7b21e$var$elm2.style.opacity = "100";
        break;
    case "/daily-deals.html":
        if ($54b47fc030b7b21e$var$elm3) $54b47fc030b7b21e$var$elm3.style.textDecoration = "underline";
        if ($54b47fc030b7b21e$var$elm3) $54b47fc030b7b21e$var$elm3.style.color = "var(--color-primary)";
        if ($54b47fc030b7b21e$var$elm3) $54b47fc030b7b21e$var$elm3.style.fontWeight = "700";
        if ($54b47fc030b7b21e$var$elm3) $54b47fc030b7b21e$var$elm3.style.opacity = "100";
        break;
}
// Navigation
// Header slider
document.addEventListener("DOMContentLoaded", function(arg) {
    var splide = new Splide(".splide", {
        focus: "center",
        rewind: true,
        arrows: true
    });
    splide.mount();
    var review_splide = new Splide(".review_splide", {
        classes: {
            pagination: "splide__pagination review-images-pagination",
            page: "splide__pagination__page review-images-pagination-page"
        },
        type: "loop",
        drag: "free",
        autoScroll: {
            speed: 1
        },
        rewind: true,
        arrows: true,
        perPage: 3,
        perMove: 1,
        // height     : '20rem',
        autoWidth: true,
        autoHeight: true,
        focus: "center",
        breakpoints: {
            600: {
                perPage: 2,
                // height : '20rem',
                autoHeight: true,
                autoWidth: true
            }
        }
    });
    review_splide.mount(window.splide.Extensions);
}); // Header slider


//# sourceMappingURL=index.4fdc9741.js.map
